<div class="mt-5 mb-5 animated fadeIn">
  <h3 class="mb-4">Muchas gracias, {{userData.name}}</h3>
  <p>Un agente se pondrá en contacto contigo lo antes posible para darte todos los detalles de tu oferta.</p>
  <img ngSrc="../../../../../assets/images/car.svg" alt="Coche" height="128" width="auto"/>
</div>
